import { InjectionToken } from '@angular/core';
import { TaskDetailState, TaskListState } from '../types';

export const DefaultTaskListState: TaskListState = {
  error: null,
  filtered: false,
  isSMEQCLoading: false,
  loading: false,
  remainingSMEQCTasks: {
    document: [],
    other: [],
    question: [],
    section: [],
  },
  remainingToDoTasks: {
    document: [],
    other: [],
    question: [],
    section: [],
  },
  tasks: [],
  tasksAlreadyLoaded: false
};

export const DEFAULT_TASK_LIST_STATE = new InjectionToken<TaskListState>(
  'Task list State',
  {
    factory: () => ({ ...DefaultTaskListState }),
  },
);

export const DefaultTaskDetailState: TaskDetailState = {
  error: null,
  filteredTask: false,
  lastRefreshedTaskId: null,
  loadingMessages: false,
  loadingTaskDetail: false,
  messageCommunicationEstablished: false,
  messages: [],
  taskDetail: null,
};

export const DEFAULT_TASK_DETAIL_STATE = new InjectionToken<TaskDetailState>(
  'Task Detail State',
  {
    factory: () => ({ ...DefaultTaskDetailState }),
  },
);
